import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';
import { useIntl } from '@amzn/storm-ui-intl';
import Button from '../../Button/Button';
import TextButton from '../../Button/TextButton';
import Text from '../../Text/Text';
import Modal from '../../Modal/Modal';
import UnorderedList from '../../List/UnorderedList';
import ListItem from '../../List/ListItem';
import type { ModalProps } from '../../Modal/Modal';
import type { TextButtonProps } from '../../Button/TextButton';
import type { ButtonProps } from '../../Button/Button';
import type { DataProps } from '../../types/DataProps';

const textSize = 'base';

const CancelTextButton = styled(TextButton)`
  margin-right: ${({ theme }) => theme.spacing.base.default};
`;

export interface WarningModalProps {
  cancelButtonProps: Omit<TextButtonProps, 'onClick'> & DataProps;
  confirmButtonProps: Omit<ButtonProps, 'onClick'> & DataProps;
  isOpen: ModalProps['isOpen'];
  label: string;
  onCancel: () => void;
  onConfirm: MouseEventHandler<HTMLElement & HTMLButtonElement & HTMLAnchorElement>;
  toggleEl: ModalProps['toggleEl'];
}

const WarningModal = ({
  cancelButtonProps,
  confirmButtonProps,
  isOpen,
  label,
  onCancel,
  onConfirm,
  toggleEl,
}: WarningModalProps) => {
  const { formatMessage } = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      hasCloseButton={false}
      footer={(
        <>
          <CancelTextButton
            {...cancelButtonProps}
            onClick={onCancel}
          >
            {formatMessage({ id: 'cancel_button_label' })}
          </CancelTextButton>
          <Button
            {...confirmButtonProps}
            onClick={onConfirm}
          >
            {label}
          </Button>
        </>
      )}
      onClose={onCancel}
      toggleEl={toggleEl}
    >
      <Text fontSize={textSize}>{formatMessage({ id: 'warning_header' })}</Text>
      <UnorderedList>
        <ListItem><Text fontSize={textSize}>{formatMessage({ id: 'warning_body_list_item_one' })}</Text></ListItem>
        <ListItem><Text fontSize={textSize}>{formatMessage({ id: 'warning_body_list_item_two' })}</Text></ListItem>
      </UnorderedList>
      <Text fontSize={textSize}>{formatMessage({ id: 'warning_footer' })}</Text>
    </Modal>
  );
}

export default WarningModal;
